import React from 'react';
import PropTypes from 'prop-types';

import './FooterSub.scss';

const FooterSubItem = ({ url, linkText }) => (
  <li>
    <FooterSubItem.Tag url={url}>
      {linkText}
    </FooterSubItem.Tag>
  </li>
);

FooterSubItem.Tag = ({ url, children }) => {
  if (url) {
    return <a href={url}>{children}</a>;
  }

  return children;
};

const FooterSub = props => (
  <div className="FooterSub">
    <div className="container-guttered">
      <nav className="FooterSub__links">
        <ul>
          {props.boringLinks.map(link => (
            <FooterSubItem key={link.url} {...link} />
          ))}
        </ul>
      </nav>
    </div>
  </div>
);

FooterSubItem.Tag.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FooterSubItem.propTypes = {
  url: PropTypes.string,
  linkText: PropTypes.string.isRequired,
};

FooterSub.propTypes = {
  boringLinks: PropTypes.arrayOf(
    PropTypes.shape(FooterSubItem.propTypes),
  ).isRequired,
};

export default FooterSub;
